import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

async function fetchEventCities(): Promise<string[]> {
  const { data, error } = await supabase
    .from('events')
    .select('location_city')
    .eq('status', 'published')
    .gte('start_datetime', new Date().toISOString())
    .not('location_city', 'is', null);

  if (error) throw error;
  
  // Extract unique cities and sort alphabetically
  const uniqueCities = [...new Set(data?.map(e => e.location_city).filter(Boolean) as string[])];
  return uniqueCities.sort((a, b) => a.localeCompare(b, 'it'));
}

export function useEventCities() {
  return useQuery({
    queryKey: ['event-cities'],
    queryFn: fetchEventCities,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 15,
  });
}
